import { Box, Button, SvgIcon, Typography } from "@mui/material";
import { paths } from "src/paths";
import EventNoteIcon from "@mui/icons-material/EventNote";
import { getCalApi } from "@calcom/embed-react";
import { useEffect } from "react";

const now = new Date();

const NeedHelp = () => {
  useEffect(() => {
    (async function () {
      const cal = await getCalApi({});
      cal("ui", {
        styles: { branding: { brandColor: "#000000" } },
        hideEventTypeDetails: false,
        layout: "month_view",
      });
    })();
  }, []);
  return (
    <Box sx={{ p: 3 }}>
      <Typography color="neutral.400" variant="subtitle1">
        Need help?
      </Typography>
      <Typography color="neutral.400" sx={{ mb: 2 }} variant="body2">
        Find a looping coach.
      </Typography>

      <Button
        component="a"
        fullWidth
        startIcon={
          <SvgIcon>
            <EventNoteIcon />
          </SvgIcon>
        }
        target="_blank"
        variant="contained"
        href="https://cal.com/team/opensourcelinic/book-an-appointment"
      >
        Make an appointment
      </Button>
    </Box>
  );
};

export default NeedHelp;
